import { P } from "../../../../../../AbstractElements";
import CommonFileUpload from "src/CommonElements/CommonFileUpload";

const ProductGallery = () => {
  return (
    <div className="product-upload">
      <P>Product Gallery</P>
      <CommonFileUpload />
    </div>
  );
};

export default ProductGallery;
